var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1128_318)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 20,
    fill: "#0078D4",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2834 30.7471C18.4705 30.7471 20.4948 30.0457 22.1459 28.8543V30.6099H26.101C25.8414 30.4267 25.6005 30.2182 25.3784 29.9844C24.905 29.5223 24.5367 28.9803 24.2738 28.3582C24.0107 27.7184 23.8792 27.0341 23.8792 26.3055C23.8792 25.5945 24.0107 24.9192 24.2738 24.2794C24.5367 23.6396 24.905 23.0798 25.3784 22.5999C25.8343 22.1378 26.3779 21.7734 27.0092 21.5069C27.3459 21.3552 27.6952 21.2439 28.057 21.1731V10.6303H22.1459V12.385C20.4948 11.1936 18.4705 10.4922 16.2834 10.4922C10.7227 10.4922 6.21484 15.0264 6.21484 20.6197C6.21484 26.2129 10.7227 30.7471 16.2834 30.7471ZM10.6503 20.6197C10.6503 23.749 13.1724 26.2857 16.2834 26.2857C19.3946 26.2857 21.9166 23.749 21.9166 20.6197C21.9166 17.4904 19.3946 14.9536 16.2834 14.9536C13.1724 14.9536 10.6503 17.4904 10.6503 20.6197Z",
    fill: "#0086FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0742 29.3219C32.4467 28.9299 32.7404 28.4797 32.9553 27.9715C33.1845 27.4632 33.2991 26.9114 33.2991 26.3161C33.2991 25.7352 33.1845 25.1834 32.9553 24.6607C32.7404 24.1379 32.4467 23.6805 32.0742 23.2884C31.6874 22.9109 31.2289 22.6132 30.6988 22.3954C30.1831 22.163 29.6315 22.0469 29.0441 22.0469C28.4567 22.0469 27.9051 22.163 27.3894 22.3954C26.8736 22.6132 26.4295 22.9109 26.057 23.2884C25.6701 23.6805 25.3693 24.1379 25.1544 24.6607C24.9395 25.1834 24.832 25.7352 24.832 26.3161C24.832 26.9114 24.9395 27.4705 25.1544 27.9933C25.3693 28.5015 25.6701 28.9444 26.057 29.3219C26.4295 29.714 26.8664 30.0189 27.3679 30.2368C27.8836 30.4546 28.4424 30.5635 29.0441 30.5635C29.6315 30.5635 30.1831 30.4546 30.6988 30.2368C31.2289 30.0189 31.6874 29.714 32.0742 29.3219Z",
    fill: "#DBAC5B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1128_318",
    x: 0,
    y: 0,
    width: 40,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.198047 0 0 0 0 0.247236 0 0 0 0 0.466346 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1128_318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "BackgroundImageFix",
    in2: "effect1_dropShadow_1128_318",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAoIcon);
export default __webpack_public_path__ + "static/media/AOIcon.3daaa44b1aa82ca97f4393b5c364d9df.svg";
export { ForwardRef as ReactComponent };